// extracted by mini-css-extract-plugin
export default {"container":"Terms_container__fBBkG","heading":"Terms_heading__Scpsg","termsbackground":"Terms_termsbackground__EXHCE"};